import { FaturaProps } from "../../interfaces/cartao.interface";
import { changePaymentMethodProps, lastDataWhiteListProps } from "../models";

export const Types = {
	FATURAS_REQUEST: "FATURAS_REQUEST",
	FATURAS_SUCCESS: "FATURAS_SUCCESS",
	FATURAS_FAILED: "FATURAS_FAILED",

	ADD_CARD_REQUEST: "ADD_CARD_REQUEST",
	ADD_CARD_CANCEL: "ADD_CARD_CANCEL",

	EDITAR_METODO_PAGAMEMTO: "EDITAR_METODO_PAGAMEMTO",

	PLANO_SELECIONADO: "PLANO_SELECIONADO",
	CONTRATO: "CONTRATO",
	TIPO: "TIPO",

	PLANOS_UPSELL: "PLANOS_UPSELL",
	ITENS_UPSELL: "ITENS_UPSELL",
	PLANOS_ITENS: "PLANOS_ITENS",
	LOADING_PLANOS_ITENS: "LOADING_PLANOS_ITENS",

	ASSINAR_PLANO: "ASSINAR_PLANO",
	ASSINAR_ITEM: "ASSINAR_ITEM",

	SELECT_ITEM: "SELECT_ITEM",
	SET_INFO_CARTAO_FALTANDO: "SET_INFO_CARTAO_FALTANDO",
	SET_MODAL_FALHA_PAGAMENTO: "SET_MODAL_FALHA_PAGAMENTO",
	SET_MODAL_BOLETO: "SET_MODAL_BOLETO",
	SET_MODAL_PIX: "SET_MODAL_PIX",
	SET_MODAL_PAGAMENTO_REALIZADO: "SET_MODAL_PAGAMENTO_REALIZADO",
	SET_MODAL_FATURA_PENDENTE: "SET_MODAL_FATURA_PENDENTE",
	SET_MODAL_PAGAMENTO_PROCESSADO: "SET_MODAL_PAGAMENTO_PROCESSADO",
	SET_MODAL_MELHOR_MOMENTO: "SET_MODAL_MELHOR_MOMENTO",
	ALTERAR_FORMA_PAGAMENTO_REQUEST: 'ALTERAR_FORMA_PAGAMENTO_REQUEST',
	SET_MODAL_PAGAMENTO_CARTAO: 'SET_MODAL_PAGAMENTO_CARTAO',
	REQUEST_PAY_ENVOICE: 'REQUEST_PAY_ENVOICE',
	SET_LOAD_CARD: 'SET_LOAD_CARD',
	SET_EXECUTED_PAYMENT: 'SET_EXECUTED_PAYMENT',
	SET_TYPE_CLIENT: 'SET_TYPE_CLIENT',
	SET_MODAL_ESCOLHA_PAGAMENTO: 'SET_MODAL_ESCOLHA_PAGAMENTO',
	SET_CHANGE_TYPE_FORM_PAYMENT: 'SET_CHANGE_TYPE_FORM_PAYMENT',
	SET_MODAL_ERROR_PIX_DATA: 'SET_MODAL_ERROR_PIX_DATA',
	SET_PAYMENT_WITH_CARD: 'SET_PAYMENT_WITH_CARD',
	SET_LOAD_CHANGE_PAYMENT_METHOD: 'SET_LOAD_CHANGE_PAYMENT_METHOD',
	SET_LAST_DATA_WHITE_LIST: 'SET_LAST_DATA_WHITE_LIST',
	REQUEST_ADD_USER_IN_WHITE_LIST: 'REQUEST_ADD_USER_IN_WHITE_LIST',

};

const INITIAL_STATE = {
	loading: false,
	loading_card: false,
	cartao: null,
	faturas: [],
	editarMetodoPagamento: null,
	plano: null,
	contrato: null,
	tipo: null,
	planos_upsell: [],
	itens_upsell: [],
	loading_upsell: false,

	assinar_plano: null,
	assinar_item: null,

	select_item: "",
	cartao_faltando: null,
	modal_falha_pagamento: false,
	error_modal_falha_pagamento: null,
	modal_boleto: false,
	fatura_selecionada: null,
	modal_pix: false,
	modal_pagamento_realizado: false,
	modal_fatura_pendente: false,
	modal_pagamento_processado: false,
	modal_melhor_momento: false,
	modal_pagamento_cartao: false,
	modal_pagamento_cartao_data: null,
	payment_executed: false,
	type_client: null,
	modal_escolha_forma_pagamento: false,
	payment_type: null,
	moda_error_pix_data: false,
	modal_payment_process_type: '',
	set_error_payment_with_card: false,
	load_change_payment_method: false,
	last_data_white_list: {},
	days_white_list: null,
};

export default function financial(state = INITIAL_STATE, action: any) {
	switch (action.type) {
		case Types.FATURAS_REQUEST:
			return {
				...state,
				loading: true,
			};
		case Types.ADD_CARD_REQUEST:
			return {
				...state,
				loading_card: true,
			};
		case Types.FATURAS_SUCCESS:
			return {
				...state,
				loading: false,
				cartao: action.payload.cartao,
				faturas: action.payload.faturas,
			};
		case Types.FATURAS_FAILED:
			return {
				...state,
				loading: false,
			};
		case Types.ADD_CARD_CANCEL:
			return {
				...state,
				loading_card: false,
			};
		case Types.EDITAR_METODO_PAGAMEMTO:
			return {
				...state,
				editarMetodoPagamento: action.payload,
			};
		case Types.PLANO_SELECIONADO:
			return {
				...state,
				plano: action.payload,
			};
		case Types.CONTRATO:
			return {
				...state,
				contrato: action.payload,
			};
		case Types.TIPO:
			return {
				...state,
				tipo: action.payload,
			};
		case Types.PLANOS_UPSELL:
			return {
				...state,
				planos_upsell: action.payload,
			};
		case Types.ITENS_UPSELL:
			return {
				...state,
				itens_upsell: action.payload,
			};
		case Types.PLANOS_ITENS:
			return {
				...state,
			};
		case Types.LOADING_PLANOS_ITENS:
			return {
				...state,
				loading_upsell: action.payload,
			};
		case Types.ASSINAR_PLANO:
			return {
				...state,
				assinar_plano: action.payload,
			};
		case Types.ASSINAR_ITEM:
			return {
				...state,
				assinar_item: action.payload,
			};
		case Types.SELECT_ITEM:
			return {
				...state,
				select_item: action.payload,
			};
		case Types.SET_INFO_CARTAO_FALTANDO:
			return {
				...state,
				cartao_faltando: action.payload,
			};
		case Types.SET_MODAL_FALHA_PAGAMENTO:
			return {
				...state,
				modal_falha_pagamento: action.payload.status,
				error_modal_falha_pagamento: action.payload.error
			};
		case Types.SET_MODAL_BOLETO:
			return {
				...state,
				modal_boleto: action.payload.status,
				fatura_selecionada: action.payload.fatura || null,
			};
		case Types.SET_MODAL_PIX:
			return {
				...state,
				modal_pix: action.payload.status,
				fatura_selecionada: action.payload.fatura || null,
			};
		case Types.SET_MODAL_PAGAMENTO_REALIZADO:
			return {
				...state,
				modal_pagamento_realizado: action.payload,
			};
		case Types.SET_MODAL_FATURA_PENDENTE:
			return {
				...state,
				modal_fatura_pendente: action.payload,
			};
		case Types.SET_MODAL_PAGAMENTO_PROCESSADO:
			return {
				...state,
				modal_pagamento_processado: action.payload.status,
				modal_payment_process_type: action.payload.type,
			};
		case Types.SET_MODAL_MELHOR_MOMENTO:
			return {
				...state,
				modal_melhor_momento: action.payload,
			};
		case Types.REQUEST_PAY_ENVOICE:
			return {
				...state,
				loading_card: true,
			}
		case Types.SET_LOAD_CARD:
			return {
				...state,
				loading_card: action.payload,
			}
		case Types.SET_EXECUTED_PAYMENT:
			return {
				...state,
				payment_executed: action.payload,
			}
		case Types.SET_TYPE_CLIENT:
			return {
				...state,
				type_client: action.payload,
			}
		case Types.SET_MODAL_ESCOLHA_PAGAMENTO:
			return {
				...state,
				modal_escolha_forma_pagamento: action.payload,
			}
		case Types.SET_CHANGE_TYPE_FORM_PAYMENT:
			return {
				...state,
				payment_type: action.payload,
			}
		case Types.SET_MODAL_ERROR_PIX_DATA:
			return {
				...state,
				moda_error_pix_data: action.payload,
			
			}
		case Types.SET_PAYMENT_WITH_CARD:
			return {
				...state,
				set_error_payment_with_card: action.payload,
			}
		case Types.SET_LOAD_CHANGE_PAYMENT_METHOD:
			return {
				...state,
				load_change_payment_method: action.payload,
			}
		case Types.SET_LAST_DATA_WHITE_LIST:
			return {
				...state,
				last_data_white_list: action.payload,
			}
		case Types.REQUEST_ADD_USER_IN_WHITE_LIST:
			return {
				...state,
				days_white_list: action.payload,
			}
		case Types.SET_MODAL_PAGAMENTO_CARTAO:
			return {
				...state,
				modal_pagamento_cartao: action.payload.status,
				modal_pagamento_cartao_data: action.payload.data,
			};
		default:
			return state;
	}
}

export const FinancialActions = {
	financial_request: (
		SERVICO_IUGU: any,
		SERVICO_SUPERLOGICA: number | string
	) => ({
		type: Types.FATURAS_REQUEST,
		payload: { SERVICO_IUGU, SERVICO_SUPERLOGICA },
	}),
	financial_request_sucess: (cartao: any, faturas: any) => ({
		type: Types.FATURAS_SUCCESS,
		payload: { cartao, faturas },
	}),
	financial_request_failed: () => ({
		type: Types.FATURAS_FAILED,
	}),
	add_card_request: (data: any) => ({
		type: Types.ADD_CARD_REQUEST,
		payload: data,
	}),
	add_card_cancel: () => ({
		type: Types.ADD_CARD_CANCEL,
	}),
	set_editar_metodo_pagamento: (MetodoPagamento: any) => ({
		type: Types.EDITAR_METODO_PAGAMEMTO,
		payload: MetodoPagamento,
	}),
	set_plano_selecionado: (plano: any) => ({
		type: Types.PLANO_SELECIONADO,
		payload: plano,
	}),
	set_contrato: (contrato: any) => ({
		type: Types.CONTRATO,
		payload: contrato,
	}),
	set_tipo: (tipo: any) => ({
		type: Types.TIPO,
		payload: tipo,
	}),
	set_plano_upsell: (plano: any) => ({
		type: Types.PLANOS_UPSELL,
		payload: plano,
	}),
	set_item_upsell: (item: any) => ({
		type: Types.ITENS_UPSELL,
		payload: item,
	}),
	set_planos_itens: () => ({
		type: Types.PLANOS_ITENS,
	}),
	set_loading_upsell: (status: any) => ({
		type: Types.LOADING_PLANOS_ITENS,
		payload: status,
	}),
	set_assinar_plano: (plano: any) => ({
		type: Types.ASSINAR_PLANO,
		payload: plano,
	}),
	set_assinar_item: (item: any) => ({
		type: Types.ASSINAR_ITEM,
		payload: item,
	}),
	set_select_item: (item: any) => ({
		type: Types.SELECT_ITEM,
		payload: item,
	}),
	set_info_cartao_faltando: (status: boolean) => ({
		type: Types.SET_INFO_CARTAO_FALTANDO,
		payload: status,
	}),
	set_modal_falha_pagamento: (status: boolean, error: string | null ) => ({
		type: Types.SET_MODAL_FALHA_PAGAMENTO,
		payload: {status, error },
	}),
	set_modal_boleto: (status: boolean, fatura?: any) => ({
		type: Types.SET_MODAL_BOLETO,
		payload: { status, fatura },
	}),
	set_modal_pix: (status: boolean, fatura: any) => ({
		type: Types.SET_MODAL_PIX,
		payload: { status, fatura },
	}),
	set_modal_pagamento_realizado: (status: boolean) => ({
		type: Types.SET_MODAL_PAGAMENTO_REALIZADO,
		payload: status,
	}),
	set_modal_fatura_pendente: (status: boolean) => ({
		type: Types.SET_MODAL_FATURA_PENDENTE,
		payload: status,
	}),
	set_modal_pagamento_processado: (status: boolean, type?: 'paymentPromess' | 'pixPayment' | 'userInWhitList' ) => ({
		type: Types.SET_MODAL_PAGAMENTO_PROCESSADO,
		payload: {status, type},
	}),
	 
	set_modal_melhor_momento: (status: boolean) => ({
		type: Types.SET_MODAL_MELHOR_MOMENTO,
		payload: status,
	}),
	alterar_forma_pagamento_request: (payload: any) => ({
		type: Types.ALTERAR_FORMA_PAGAMENTO_REQUEST,
		payload,
	}),
	set_modal_pagamento_cartao: (status: boolean, data: FaturaProps | null) => ({
		type: Types.SET_MODAL_PAGAMENTO_CARTAO,
		payload: {status, data}
	}),
	set_request_pay_envoice: ()=>({
		type: Types.REQUEST_PAY_ENVOICE,
	}),
	set_load_card: (status: boolean)=>({
		type: Types.SET_LOAD_CARD,
		payload: status
	}),
	set_payment_executed: (status:boolean)=>({
		type: Types.SET_EXECUTED_PAYMENT,
		payload: status
	}),
	set_type_client: (type: 'bank_slip_pix' | 'card' | null)=>({
		type: Types.SET_TYPE_CLIENT,
		payload: type
	}),
	set_modal_escolha_pagamento: (status: boolean)=>({
		type: Types.SET_MODAL_ESCOLHA_PAGAMENTO,
		payload: status
	}),
	set_change_type_form_payment: (type: 'bank_slip' | 'pix' | 'card' | null)=>({
		type: Types.SET_CHANGE_TYPE_FORM_PAYMENT,
		payload: type
	}),
	modal_error_pix_data: (status: boolean)=>({
		type: Types.SET_MODAL_ERROR_PIX_DATA,
		payload: status
	}),

	set_payment_error_with_card: (status:boolean)=>({
		type: Types.SET_PAYMENT_WITH_CARD,
		payload: status
	}),
	set_load_change_payment_method: (load: boolean)=>({
		type: Types.SET_LOAD_CHANGE_PAYMENT_METHOD,
		payload: load
	}),
	set_last_data_white_list: (data: lastDataWhiteListProps)=>({
		type: Types.SET_LAST_DATA_WHITE_LIST,
		payload: data
	}),
	set_request_add_user_in_white_list: (days: number | null)=>({
		type: Types.REQUEST_ADD_USER_IN_WHITE_LIST,
		payload: days
	}),
};
